module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_7016.11a245c4.png";